<template>
    <div
        id="noCtrlScrollZoom"
        class="container-fluid"
        @mouseenter="calenderHover=true"
        @mouseleave="calenderHover=false"
        v-wheel:200.debounce="stepHandler"
        @keydown.esc="isFullScreen=false"
    >
        <div class="card">
            <div class="card-body p-3">
                <div class="row align-items-center">
                    <div class="col-md-auto d-none d-sm-block col order-1 order-lg-0">
                        <Button class="btn text-muted" v-b-tooltip @click="prevWeek()">
                            <i class="fe fe-chevron-left"></i>
                        </Button>
                        <Button class="btn text-muted" v-b-tooltip @click="thisWeek()">
                            <i class="fe fe-circle"></i>
                        </Button>
                        <Button class="btn text-muted" v-b-tooltip @click="nextWeek()">
                            <i class="fe fe-chevron-right"></i>
                        </Button>
                    </div>

                    <!--  Calendar controls mobile -->
                    <div
                        class="col-lg-auto d-block d-sm-none col-auto order-lg-0 order-1 mobileNoPadding position-absolute"
                        style="bottom: 12px;"
                    >
                        <b-button-group size="md">
                            <b-button variant="white" @click="prevWeek()">
                                <i class="fe fe-chevrons-left"></i>
                            </b-button>

                            <b-button
                                class="btn"
                                variant="white"
                                v-if="view.value=='staff' || view.value == 'day'"
                                id="calendarMobile"
                                @click="openDatePicker('calendarMobile')"
                            >
                                <i class="fe fe-calendar"></i>
                            </b-button>
                            <b-button variant="white" @click="nextWeek()">
                                <i class="fe fe-chevrons-right"></i>
                            </b-button>
                        </b-button-group>
                    </div>

                    <!-- views 7days, 3days, etc -->
                    <div class="col-auto d-none d-lg-block">
                        <div class="dropdown">
                            <b-button-group>
                                <b-dropdown variant="white" right :text="$t(view.label)">
                                    <b-dropdown-item
                                        v-for="(item, index) in views"
                                        :key="index"
                                        @click.prevent="view = item;"
                                        href="#"
                                        :disabled="item.value == view.value"
                                    >{{ $t(item.label) }}
                                    </b-dropdown-item>
                                </b-dropdown>
                            </b-button-group>
                        </div>
                    </div>

                    <!-- day name on click calendar -->
                    <div class="col-lg-auto col-12 text-center order-0">
                        <h2 class="mb-4 mb-md-0" id="appendHere">
                            <span
                                @click="openDatePicker('appendHere')"
                                class="pointer"
                            >
                                {{ formatDate(start) }}
                                <i class="fe fe-chevron-down position-relative"
                                   style="font-size: 18px; top: 2px; left: -2px;"></i>
                            </span>
                        </h2>
                    </div>

                    <!-- helper col for space left and right -->
                    <div class="col d-none d-lg-block"></div>

                    <!-- helper col for space left and right -->
                    <div class="col d-lg-none d-block order-2"></div>

                    <!-- staff views 7days, 3days, etc -->
                    <div class="col-auto d-none d-md-block" v-if="view.value === 'staff'">
                        <div class="dropdown">
                            <b-button-group>
                                <b-dropdown variant="white" right :text="$t(staffView.option.label)">
                                    <b-dropdown-item
                                        v-for="(item, index) in viewsOptions"
                                        :key="index"
                                        @click.prevent="item.value = 'staff'; item.label = 'By Staff'; staffView = item"
                                        href="#"
                                        :disabled="item.option.value === staffView.option.value"
                                    >{{ $t(item.option.label) }}
                                    </b-dropdown-item>
                                </b-dropdown>
                            </b-button-group>
                        </div>
                    </div>

                    <!-- workplace views 7days, 3days, etc -->
                    <div class="col-auto d-none d-md-block" v-if="view.value === 'workplace'">
                        <div class="dropdown">
                            <b-button-group>
                                <b-dropdown variant="white" right :text="$t(workplaceView.option.label)">
                                    <b-dropdown-item
                                        v-for="(item, index) in viewsOptions"
                                        :key="index"
                                        @click.prevent="item.value = 'workplace'; item.label = 'By workplaces'; workplaceView = item;"
                                        href="#"
                                        :disabled="item.option.value === workplaceView.option.value"
                                    >{{ $t(item.option.label) }}
                                    </b-dropdown-item>
                                </b-dropdown>
                            </b-button-group>
                        </div>
                    </div>

                    <!-- toolbar -->
                    <div class="col-auto order-2">
                        <b-button-toolbar>
                            <b-button-group>
                                <!-- hide past filter -->
                                <button class="btn btn-white m-0 p-0 d-none d-xl-block">
                                    <div class="dropdown">
                                        <b-button-group>
                                            <button
                                                class="btn btn-white"
                                                v-if="hidePast || showCancelled"
                                                @click="hidePast = false; showCancelled = false"
                                            >
                                                <span class="fe fe-x"></span>
                                            </button>
                                            <b-dropdown
                                                v-b-tooltip
                                                :title="$t('Status')"
                                                right
                                                variant="link"
                                                toggle-class="text-decoration-none"
                                                no-caret
                                                class="btn-link-reset"
                                            >
                                                <template #button-content>
                                                    <span class="fe"
                                                          :class="[ hidePast || showCancelled ? 'fe-eye' : 'fe-eye-off']"></span>
                                                </template>
                                                <div class="pt-2 pb-2 pl-3 pr-3">
                                                    <b-form-checkbox v-model="hidePast" class="text-nowrap">
                                                        {{ $t('Hide past') }}
                                                    </b-form-checkbox>
                                                </div>
                                                <div class="pt-2 pb-2 pl-3 pr-3">
                                                    <b-form-checkbox
                                                        v-model="showCancelled"
                                                        class="text-nowrap"
                                                    >{{ $t('Show Cancelled') }}
                                                    </b-form-checkbox>
                                                </div>
                                            </b-dropdown>
                                        </b-button-group>
                                    </div>
                                </button>

                                <!-- team filter -->
                                <button
                                    v-if="staff.length && view.value !== 'staff'"
                                    class="btn btn-white m-0 p-0 d-none d-xl-block"
                                >
                                    <team-filter
                                        v-model="staffQuery"
                                        :params="{query:{public:true}}"
                                        :is-icon-view="true"
                                        custom-x-style="no-border"
                                    ></team-filter>
                                </button>

                                <!-- workplace filter -->
                                <button
                                    v-if="workPlaces.length && view.value !== 'workplace'"
                                    class="btn btn-white m-0 p-0 d-none d-xl-block"
                                >
                                    <work-place-filter
                                        v-model="workPlaceQuery"
                                        :is-icon-view="true"
                                        custom-x-style="no-border"
                                    ></work-place-filter>
                                </button>

                                <b-button
                                    variant="white"
                                    id="popover-calendar-step"
                                    class="d-none d-xl-block"
                                    v-b-tooltip
                                    :title="$t('Scale')"
                                    v-if="view.value !== 'month'"
                                >
                                    <i
                                        style="font-size: 15px"
                                        class="fe fe-settings"
                                        :class="{'spin-icon': isSaving}"
                                    ></i>
                                    <b-popover target="popover-calendar-step" triggers="click" placement="bottom"
                                               style="width:100px">
                                        <step-slider></step-slider>
                                    </b-popover>
                                </b-button>

                                <b-button
                                    v-b-tooltip
                                    :title="$t('Show as a list')"
                                    variant="white"
                                    class="order-3"
                                    @click="$router.push({name:'appointments.filter', params:{ filter: 'today' }})"
                                >
                                    <span class="fe fe-list"></span>
                                </b-button>

                                <b-button
                                    class="order-4"
                                    @click="openModal({id:'inWaitingListAppointmentModal'})"
                                    variant="white"
                                    size="md"
                                    v-b-tooltip.hover
                                    :title="$t('Show waiting list')"
                                >
                                    <i class="fe fe-book-open" style="font-size: 15px"></i>
                                    <span class="text-warning position-absolute waitingListBadge"
                                          v-if="inWaitingListCount>0">
									                      <b-badge variant="warning">{{ inWaitingListCount }}</b-badge>
									                  </span>
                                </b-button>

                                <b-button
                                    variant="white"
                                    class="d-none d-xl-block order-5"
                                    @click="isFullScreen = !isFullScreen"
                                    v-b-tooltip.hover
                                    :title="isFullScreen ? $t('Back') : $t('Full Screen')"
                                >
                                    <i class="fe fe-maximize" style="font-size: 15px" v-if="!isFullScreen"/>
                                    <i class="fe fe-minimize" style="font-size: 15px" v-else/>
                                </b-button>
                            </b-button-group>
                        </b-button-toolbar>
                    </div>

                    <!-- filter button -->
                    <div class="col-auto d-xl-none mobileNoPadding order-3">
                        <b-button @click="openModal({id:'calendarFilterModal'})" variant="white" size="md">
                            <i class="fe fe-filter"></i>
                        </b-button>
                    </div>

                </div>
            </div>
        </div>

        <!--staff calendar-->
        <mode-staff-advanced
            v-if="view.value==='staff'"
            class="container-fluid container-grid"
            :class="{'border': heading.length}"
            :heading="heading"
            :staff="staff"
            :areDataLoading="areDataLoading"
            :rows="rows"
            :lineHeight="lineHeight"
            :createModal="createModal"
            :start="start"
            :dateTime="dateTime"
            :isNow="isNow"
            :events="events"
            @clickEvent="clickEvent"
            :step="step"
            :change="change"
            :createBlockAppointmentTimeModal="createBlockAppointmentTimeModal"
            :isToday="isToday"
            :confirmMove="confirmMove"
        ></mode-staff-advanced>

        <!--workplace calendar-->
        <mode-workplace-advanced
            v-else-if="view.value==='workplace'"
            class="container-fluid container-grid"
            :class="{'border': workPlaces.length}"
            :heading="heading"
            :workPlaces="workPlaces"
            :areDataLoading="areDataLoading"
            :rows="rows"
            :lineHeight="lineHeight"
            :createModal="createModal"
            :start="start"
            :dateTime="dateTime"
            :isNow="isNow"
            :events="events"
            @clickEvent="clickEvent"
            :step="step"
            :change="change"
            :createBlockAppointmentTimeModal="createBlockAppointmentTimeModal"
            :isToday="isToday"
            :confirmMove="confirmMove"
        ></mode-workplace-advanced>

        <!--Monthly calendar-->
        <mode-monthly
            v-else-if="view.value==='month'"
            v-touch:swipe="swipeHandler"
            :heading="heading"
            :areDataLoading="areDataLoading"
            :isToday="isToday"
            :rows="rows"
            :lineHeight="lineHeight"
            :createModal="createModal"
            :start="start"
            :dateTime="dateTime"
            :isNow="isNow"
            :events="events"
            @clickEvent="clickEvent"
            :step="step"
            :change="change"
            :createBlockAppointmentTimeModal="createBlockAppointmentTimeModal"
            :list="list"
            :confirmMove="confirmMove"
            :monthDate="monthDate"
            @goToCalendarType="goToCalendarType"
        ></mode-monthly>

        <!--weekly, daily, three weeks calendar-->
        <mode-week
            v-else
            class="container-fluid container-grid"
            v-touch:swipe="swipeHandler"
            :class="{'border': heading.length}"
            :heading="heading"
            :areDataLoading="areDataLoading"
            :isToday="isToday"
            :rows="rows"
            :lineHeight="lineHeight"
            :createModal="createModal"
            :start="start"
            :dateTime="dateTime"
            :isNow="isNow"
            :events="events"
            @clickEvent="clickEvent"
            :step="step"
            :change="change"
            :createBlockAppointmentTimeModal="createBlockAppointmentTimeModal"
            :list="list"
            :confirmMove="confirmMove"
        ></mode-week>



        <appointment-view-modal id="AppointmentViewModal" :appointment="model"></appointment-view-modal>

        <date-picker
            class="invisible"
            :calendarOptions="calendarOptions"
            v-model="start"
            v-if="start"
            ref="datePickerWrap"
        ></date-picker>

        <!-- left side Filters modal on Mobile-->
        <mobile-filters-modal id="calendarFilterModal">

            <!-- status filter -->
            <div class="col-12 mb-3" style="z-index: 101;">
                <div class="dropdown">
                    <b-button-group>
                        <button
                            class="btn btn-white"
                            v-if="hidePast || showCancelled || showDrafts"
                            @click="hidePast = false; showCancelled = false; showDrafts = false;"
                        >
                            <span class="fe fe-x"></span>
                        </button>
                        <b-dropdown variant="white" right :text="$t('Status')">
                            <div class="pt-2 pb-2 pl-3 pr-3">
                                <b-form-checkbox v-model="hidePast" class="text-nowrap">{{
                                        $t('Hide past')
                                    }}
                                </b-form-checkbox>
                            </div>
                            <div class="pt-2 pb-2 pl-3 pr-3">
                                <b-form-checkbox v-model="showDrafts" class="text-nowrap">{{ $t('Show online appointments') }}</b-form-checkbox>
                            </div>
                            <div class="pt-2 pb-2 pl-3 pr-3">
                                <b-form-checkbox v-model="showCancelled" class="text-nowrap">{{ $t('Show Cancelled') }}</b-form-checkbox>
                            </div>
                        </b-dropdown>
                    </b-button-group>
                </div>
            </div>

            <!-- team filter -->
            <div class="col-12 mb-3" v-if="view.value!='staff'">
                <team-filter v-model="staffQuery" :params="{query:{public:true}}"></team-filter>
            </div>

            <!-- views 7days, 3days, etc -->
            <div class="col-12 mb-3 d-lg-none">
                <div class="dropdown">
                    <b-button-group>
                        <b-dropdown variant="white" right :text="$t(view.label)">
                            <b-dropdown-item
                                v-for="(item, index) in views"
                                :key="index"
                                @click.prevent="view=item"
                                href="#"
                                :disabled="item.value == view.value"
                                v-show="item.value == 'day' || item.value == '3days'"
                            >{{ $t(item.label) }}
                            </b-dropdown-item>
                        </b-dropdown>
                    </b-button-group>
                </div>
            </div>

            <!-- workplace filter -->
            <div class="col-12 mb-3" v-if="view.value!='staff'">
                <work-place-filter v-model="workPlaceQuery"></work-place-filter>
            </div>

            <!-- calendar size STEP -->
            <div class="col-12 mb-3">
                <step-slider></step-slider>
            </div>
        </mobile-filters-modal>

        <in-waiting-list-modal
            id="inWaitingListAppointmentModal"
            @waitingListTabChanged="waitingListTab = $event"
            :currentTab="waitingListTab"
            >

            <event-in-waiting-list
                v-if="inWaitingListEvents().length"
                class="pointer draggable"
                :events="inWaitingListEvents()"
                :change="change"
                :move="confirmMove"
                :clickEvent="clickEvent"
            ></event-in-waiting-list>

            <div v-else class="d-flex">
                <span class="card-body text-center small text-muted">
                    {{ waitingListTab == 'drafts' ? $t('No waiting online appointments') : $t('No waiting appointments')}}
                </span>
            </div>
        </in-waiting-list-modal>

    </div>
</template>

<script>
import debounce from 'lodash/debounce';
import Event from './Event.vue';
import draggable from 'vuedraggable'
import {modalMixins} from '@/mixins/modal.js'
import {companyMixins} from '@/Pages/Company/mixins.js'
import {mapActions, mapGetters, mapState} from 'vuex';
import AppointmentViewModal from '@/Pages/Appointments/ViewModal.vue';
import TeamFilter from "@/components/TeamFilter";
import Avatar from "@/components/Avatar";
import DatePicker from '@/components/DatePicker';
import WorkPlaceFilter from "../../Pages/Company/WorkPlaces/WorkPlaceFilter";
import StepSlider from "@/components/Calendar/StepSlider";
import EventInWaitingList from "./EventInWaitingList.vue";
import InWaitingListModal from "./InWaitingListModal.vue";
import mobileFiltersModal from "@/components/mobileFiltersModal";
import ModeWorkplaceAdvanced from "./Mode/WorkplaceAdvanced";
import ModeWeek from "./Mode/Week";
import ModeStaffAdvanced from "./Mode/StaffAdvanced";
import ModeMonthly from "./Mode/Monthly";


export default {
    components: {
        StepSlider,
        WorkPlaceFilter,
        Avatar,
        draggable,
        Event,
        DatePicker,
        TeamFilter,
        AppointmentViewModal,
        EventInWaitingList,
        InWaitingListModal,
        mobileFiltersModal,
        ModeWorkplaceAdvanced,
        ModeWeek,
        ModeStaffAdvanced,
        ModeMonthly,
    },
    mixins: [modalMixins, companyMixins],
    data() {
        return {
            monthDate: this.$moment(),
            isFullScreen: false,
            isMobileFilter: false,
            screenWidth: null,
            isMobile: false,
            wheelHandler: null,
            viewsOptions: [
                {value: 'staff', label: 'By Staff', option: {value: 7, type: 'days', label: 'Week'}},
                {value: 'staff', label: 'By Staff', option: {value: 3, type: 'days', label: '3 Days'}},
                {value: 'staff', label: 'By Staff', option: {value: 1, type: 'day', label: 'Day'}}
            ],
            // view: { value: '3days', label: '3 Days', option: { value: 3, type: 'days' } },
            views: [
                {value: 'week', label: 'Week', option: {value: 7, type: 'days'}},
                {value: '3days', label: '3 Days', option: {value: 3, type: 'days'}},
                {value: 'day', label: 'Day', option: {value: 1, type: 'day'}},
                {value: 'staff', label: 'By Staff', option: {value: 1, type: 'day', label: 'Day'}},
                {value: 'workplace', label: 'By workplaces', option: {value: 1, type: 'day', label: 'Day'}},
                {value: 'month', label: 'Month', option: {value: 0, type: 'month'}},
            ],
            list: {},
            calenderHover: false,
            stepRange: 0,
            defaultSteps: [5, 15, 30, 45, 60],
            pendingStepPromise: null,
            staffQuery: [],
            workPlaceQuery: [],
            appointments: {},
            start: this.$moment().format(),
            hidePast: true,
            showCancelled: false,
            showDrafts: false,
            params: {
                query: {
                    $limit: 1000,
                    $sort: {
                        startAt: 1
                    },
                    startAt: {
                        $gte: this.$moment(this.start).startOf('today'),
                        $lte: this.$moment(this.start).add('1', 'week').endOf('week')
                    },
                    status: {$nin: ['cancelled', 'noshow']},
                    inWaitingList: {
                        $ne: true
                    },
                    draft: {$ne: true}
                }
            },
            inWaitingListParams: {
                query: {
                    $limit: 1000,
                    $sort: {
                        startAt: 1
                    },
                    status: {$nin: ['cancelled', 'noshow', 'completed']},
                    inWaitingList: true
                }
            },
            inWaitingListCount: null,
            hideForm: false,
            calendarOptions: {
                disableMobile: true,
                "disable": [
                    (date) => {
                        if (!this.company.schedule.find(o => this.$moment().isoWeekday(this.$dayOfWeek(o.dayOfWeek)).weekday() === this.$moment(date).weekday()))
                            return true
                    }
                ],
            },
            waitingListTab: 'waitingList',
        }
    },
    watch: {
        isFullScreen: {
            handler(newVal) {
                if (newVal) {
                    this.$pageFullScreen(true)
                } else {
                    this.$pageFullScreen(false)
                }
            },
            deep: true
        },
        showCancelled: {
            handler(newVal) {
                this.settings.ShowCalendarCancelled = newVal;
                this.saveUserSettings();
            },
            deep: true
        },
        hidePast: {
            handler(newVal) {
                this.settings.HideCalendarPrevious = newVal;
                this.saveUserSettings();
            },
            deep: true
        },
        start: {
            handler(newVal) {
                if (this.view.value === 'month')
                    this.monthDate = this.$moment(newVal)
            }
        },
        showDrafts: {
            handler(newVal) {
                if (!newVal) {
                    this.params.query.draft = {$ne: true};
                } else {
                    delete this.params.query.draft
                }
                this.settings.ShowCalendarDrafts = newVal;
                this.fetchAppointments();
                this.saveUserSettings();
            },
            deep: true
        },
        start: debounce(function (newValue) {
            this.params.query.startAt = {
                $gte: this.$moment(this.heading[0]).subtract(this.view.option.value, this.view.option.type),
                $lte: this.$moment(this.heading[this.heading.length - 1]).add(this.view.option.value, this.view.option.type)
            };
            this.fetchAppointments('start');
        }, 600),

        monthDate: debounce(function(newVal) {
            const calendar = [];
            const today = newVal;
            const startDay = today.clone().startOf('month').startOf('week');
            const endDay = today.clone().endOf('month').endOf('week');
            let date = startDay.clone().subtract(1, 'day');
            while (date.isBefore(endDay, 'day'))
                calendar.push({
                    days: Array(7).fill(0).map(() => date.add(1, 'day').clone())
                });

            Promise.all(calendar.map(el => {
                const query = {
                    ...this.params.query,
                    startAt: {
                        $gte: this.$moment(el.days[0].startOf('week')),
                        $lte: this.$moment(el.days[0].endOf('week'))
                    }
                };
                let params = {
                    ...this.params,
                    query
                };
                return this.fetchAppointments('month', params)
            }))
        }, 600),

        staffQuery(newVal) {
            this.settings.staffQuery = newVal;
            this.saveUserSettings()
        },

        workPlaceQuery(newVal) {
            this.settings.workPlaceQuery = newVal;
            this.saveUserSettings()
        },

        stepRange(newWal) {
            this.setStepGlobal(this.defaultSteps[newWal]);
        },

        paramsQueries: {
            handler: debounce(function(newVal) {
                this.fetchAppointments('byNewQuery', newVal);
            }, 750),

            deep: true
        },
    },
    mounted() {
        window.onpopstate = function(event) {
            let topBar = document.querySelector("#app-top-bar");
            let sideBar = document.querySelector("#app-sidebar");
            if (topBar !== null && sideBar !== null) {
                topBar.style.display = 'block';
                sideBar.style.display = 'block';
            }
        };
        this.handleResize();
        // remove ctrl+zoom on browser for #noCtrlScrollZoom
        let wrapperDiv = document.getElementById('noCtrlScrollZoom');
        if (wrapperDiv)
            wrapperDiv.addEventListener('wheel', event => {
                if (event.ctrlKey)
                    event.preventDefault();
            }, {passive: false});
        window.addEventListener('resize', this.handleResize);
        this.workPlaceQuery = this.settings.workPlaceQuery || [];
        this.staffQuery = this.settings.staffQuery || []
    },
    updated() {
        this.$nextTick(() => {
            this.handleResize()
        })
    },
    created() {
        this.hidePast = this.settings.HideCalendarPrevious;
        this.showCancelled = this.settings.ShowCalendarCancelled;
        this.showDrafts = this.settings.ShowCalendarDrafts;

        if (this.view.value === 'month') {
            this.monthDate = this.$moment();
        }
        // this.fetchAppointments('created');
        this.fetchAppointments("waitingList", this.inWaitingListParams).then(response => {
            this.inWaitingListCount = response.total
        });
        window.addEventListener('resize', this.handleResize);
        this.handleResize();
        this.setStep();
        this.findWorkPlaces();
    },
    destroyed() {
        window.removeEventListener('resize', this.handleResize);
    },
    computed: {
        ...mapState('appointment', {areDataLoading: 'isFindPending'}),
        ...mapGetters('appointment', {findDataInStore: 'find'}),
        ...mapGetters('my-team', {findTeamInStore: 'find', user: 'get'}),
        ...mapGetters('treatment', {treatment: 'get'}),
        ...mapState('auth', {currentUser: 'user'}),
        ...mapState('profile', {isSaving: 'isPatchPending'}),
        ...mapGetters('work-place', {findWorkPlacesInStore: 'find'}),
        ...mapState('work-place', {areWorkPlacesLoading: 'isLoading'}),

        workPlaces() {
            return this.findWorkPlacesInStore({query: {_id: {$ne: 'temp'}}}).data;
        },

        workplaceView: {
            set(newValue) {
                this.settings.CalendarCurrent = newValue;
                this.handleResize();
                this.saveUserSettings();
            },
            get() {
                return this.settings.CalendarCurrent;
            }
        },

        staffView: {
            set(newValue) {
                this.settings.CalendarCurrent = newValue;
                this.handleResize();
                this.saveUserSettings();
            },
            get() {
                return this.settings.CalendarCurrent;
            }
        },

        view: {
            set(newValue) {
                this.settings.CalendarCurrent = newValue;
                this.handleResize();
                this.saveUserSettings();
            },
            get() {
                return this.settings.CalendarCurrent;
            }
        },
        appointmentList() {
            return this.findDataInStore(this.params).data;
        },

        step() {
            return this.settings.calendarStep
        },

        lineHeight() {
            return 15 + this.step || 0
        },

        hidePastOld: {
            set(newValue) {
                this.settings.HideCalendarPrevious = newValue;
                this.saveUserSettings();
            },
            get() {
                return this.settings.HideCalendarPrevious;
            }
        },

        settings: {
            get() {
                this.handleResize();
                let settings = {
                    HideCalendarPrevious: true,
                    CalendarCurrent: {
                        value: '3days', label: '3 Days', option: {value: 3, type: 'days'}
                    },
                    calendarStep: this.$settings.calendarStep
                };
                if (this.currentUser.settings)
                    settings = {...settings, ...this.currentUser.settings};
                if (this.currentUser.mobileSettings && this.isMobile)
                    settings = {...settings, ...this.currentUser.mobileSettings};
                return settings;
            }
        },
        today() {
            return this.$moment().format();
        },

        staff() {
            let params = {query: {public: true}};
            return this.findTeamInStore(params).data;
        },
        week() {
            let days;

            if (this.view.value === 'day' ||
                this.view.value === 'staff' && this.view.option.value === 1 ||
                this.view.value === 'workplace' && this.view.option.value === 1) {
                days = {
                    start: this.$moment(this.start),
                    end: this.$moment(this.start).endOf('day'),
                };
            } else if (this.view.value === '3days' ||
                this.view.value === 'staff' && this.view.option.value === 3 ||
                this.view.value === 'workplace' && this.view.option.value === 3) {
                days = {
                    start: this.$moment(this.start),
                    end: this.$moment(this.start).add(2, 'day'),
                };
            } else {
                days = {
                    start: this.$moment(this.start).startOf('week'),
                    end: this.$moment(this.start).endOf('week'),
                };
            }

            return days;
        },

        heading() {
            let start = this.week.start.clone();
            let end = this.week.end.clone();
            let slots = [];
            while (start <= end) {
                let scheduledDay = this.isScheduleDay(start);
                if (scheduledDay)
                    slots.push(start.format());
                else if (this.view.value === '3days') {
                    end.add(1, 'day');
                }
                start.add(1, 'day');
            }
            return slots;
        },
        rows() {
            let maxHour = 18;
            let maxMinute = 0;
            let minHour = 9;

            if (this.company.schedule) {
                maxHour = Math.max.apply(Math, this.company.schedule.map(function(o) {
                    return o.endHour;
                }));
                maxMinute = Math.max.apply(Math, this.company.schedule.map(function(o) {
                    return o.endMinute;
                }));
                minHour = Math.min.apply(Math, this.company.schedule.map(function(o) {
                    return o.startHour;
                }))
            }


            let step = this.step;
            let start = this.$moment().set({hour: minHour, minutes: 0});
            let end = this.$moment().set({hour: maxHour, minutes: maxMinute});
            let slots = [];
            for (let minutes = start; minutes <= end; minutes.add(step, 'minutes')) {
                slots.push(minutes.format());
            }
            return slots;
        },

        paramsQueries() {
            let query = this.params.query;

            if (this.staffQuery.length <= 0) {
                delete query['services.userId'];
            } else {
                query['services.userId'] = {$in: this.staffQuery};
            }

            if (this.workPlaceQuery.length <= 0) {
                delete query['services.workPlaceId'];
            } else {
                query['services.workPlaceId'] = {$in: this.workPlaceQuery};
            }

            if (this.showCancelled) {
                delete query.status
            } else {
                query.status = {$nin: ['cancelled', 'noshow']};
            }

            if (this.hidePast) {
                query.startAt.$gte = this.$moment(this.start).startOf('today');
            } else {
                if (this.view.value === 'month') {
                    query.startAt.$gte = this.$moment(this.start).startOf('month');
                } else {
                    query.startAt.$gte = this.$moment(this.start).startOf('week');
                }
            }

            query.startAt = {
                $gte: this.$moment(this.heading[0]).subtract(this.view.option.value, this.view.option.type),
                $lte: this.$moment(this.heading[this.heading.length - 1]).add(this.view.option.value, this.view.option.type)
            };

            this.params.query = query;
            return this.params;
        }
    },
    methods: {
        ...mapActions('appointment', ['find', 'patch']),
        ...mapActions('profile', {updateUser: 'patch'}),
        ...mapActions('work-place', {findWorkPlaces: 'find'}),

        isScheduleDay(date) {
            return !!this.company.schedule.find(o => {
                return this.$moment().isoWeekday(this.$dayOfWeek(o.dayOfWeek)).weekday() === date.weekday()
            })
        },

        onClick(e) {
            console.log(e)
        },

        swipeHandler(touchEvent) {
            if (touchEvent === 'left') {
                this.nextWeek();
            } else if (touchEvent === 'right') {
                this.prevWeek();
            }
        },
        openDatePicker(position) {
            const flatPickrInstance = this.$refs.datePickerWrap.$refs.datePickerWrap.fp;
            flatPickrInstance._positionElement = window.document.getElementById(position); // eslint-disable-line
            flatPickrInstance.open();
        },

        saveUserSettings: debounce(function() {
            const currentUserSettings = this.isMobile ? this.currentUser.mobileSettings : this.currentUser.settings;
            if (JSON.stringify(currentUserSettings) === JSON.stringify(this.settings)) return;
            if (this.isMobile)
                return this.updateUser(['me', {mobileSettings: this.settings}, {}]);
            return this.updateUser(['me', {settings: this.settings}, {}]);
        }, 300),

        handleResize() {
            this.screenWidth = window.innerWidth;
            this.isMobile = this.screenWidth <= 576;
        },

        isNow(date) {
            return this.$moment(date).isBetween(
                this.$moment(),
                this.$moment().add('15', 'minutes'), 'minute'
            );
        },

        confirmMove: function(event) {
        },

        isToday(date) {
            return this.$moment(date).isSame(this.$moment(), 'day');
        },
        memberStyles(color) {
            return 'border-right:3px solid ' + color;
        },

        change: function(event, newDate) {
            if (!event.added) return;

            let item = event.added.element;

            if (!window.confirm(this.$t('Do you confirm ?'))) {
                this.patch([item._id, {__v: 1233 + Math.random()}]);
                return;
            }

            let data = {
                services: [],
                startAt: this.$moment(newDate).format(),
                endAt: this.$moment(newDate).subtract(item.duration, 'minutes').format(),
            };

            let serviceStartTime = data.startAt;
            item.services.map(service => {
                service.startAt = serviceStartTime;
                data.services.push(service);
                serviceStartTime = this.$moment(service.startAt).add(service.duration, 'minutes');
            });

            this.patch([item._id, data]);
            this.$toasted.global.success({
                message: this.$t('Appointment has been rescheduled')
            });
        },
        clickEvent(event) {
            this.openModal({id: 'AppointmentViewModal', model: event});
        },
        createFastModal(startAt) {
            let appointment = {
                model: {
                    startAt,
                    services: [{
                        startAt: startAt
                    }]
                },
                _id: 'temp'
            };
            const {Appointment} = this.$FeathersVuex;
            new Appointment(appointment);

            this.openModal({id: 'AppointmentFastModal'});
        },
        createModal(startAt, options = {userId: null, workPlaceId: null}, endAt) {
            let appointment = {
                model: {
                    startAt,
                    endAt,
                    services: [{
                        startAt: startAt,
                        userId: options.userId || null,
                        workPlaceId: options.workPlaceId || null
                    }],
                    userId: options.userId || null
                },
                _id: 'temp'
            };
            const {Appointment} = this.$FeathersVuex;
            new Appointment(appointment);

            this.openModal({id: 'AppointmentFastModal'});
        },

        populateAppointments(appointments) {
            return appointments.map(appointment => {
                const duration = this.$moment(appointment.startAt).diff(this.$moment(appointment.endAt), 'minutes');
                let colors = [];
                const services = appointment.services.map(service => {
                    const user = this.user(service.userId);
                    const treatment = this.treatment(service.treatmentId);
                    if (user) {
                        colors.push(user.color);
                    }
                    return {...service, user, treatment}
                });
                colors = colors.filter((value, index, self) => self.indexOf(value) === index);
                return {...appointment, colors, duration, services}
            })
        },

        inWaitingListEvents() {
            let list = this.findDataInStore(this.waitingListTab == 'waitingList' ? this.inWaitingListParams : {
                query: {
                    $limit: 1000,
                    $sort: {
                        startAt: 1
                    },
                    draft: true
                }
            });
            let items = list.data;
            this.inWaitingListCount = list.total;

            if (items.length === 0)
                return [];

            return this.populateAppointments(items);
        },
        createBlockAppointmentTimeModal(startAt, options = {userId: null, workPlaceId: null}, endAt) {
            let appointment = {
                model: {
                    startAt,
                    endAt,
                    services: [{
                        startAt: startAt,
                        userId: options.userId || null,
                        workPlaceId: options.workPlaceId || null
                    }]
                },
                _id: 'temp'
            };
            const {Appointment} = this.$FeathersVuex;
            new Appointment(appointment);

            this.openModal({id: 'BlockAppointmentTimeModal'});
        },

        sortByColor(appointments) {
            return appointments.slice().sort((a, b) => {
                if (!a.colors.length)
                    return 1;
                if (!b.colors.length)
                    return -1;
                let colorA = a.colors[0];
                let colorB = b.colors[0];
                if (!colorA)
                    return 1;
                if (!colorB)
                    return -1;
                colorA = colorA.toLowerCase();
                colorB = colorB.toLowerCase();
                return colorA.localeCompare(colorB);
            })
        },

        events(date, options = {userId: null, workPlaceId: null}) {
            let params = JSON.parse(JSON.stringify(this.params));

            if (this.hidePast && this.$moment(date).isBefore(this.$moment())) {
                params.query.endAt = {
                    $lt: this.$moment(date)
                }
            }

            let startLT = this.$moment(date).add(this.step, 'minutes');
            if (this.view.value === 'month')
                startLT = this.$moment(date).add(1, 'day');

            params.query.startAt = {
                $gte: date,
                $lt: startLT
            };

            if (options.userId) {
                params.query['services.userId'] = options.userId;
            }

            if (options.workPlaceId) {
                params.query.services = {workPlaceId: {$in: options.workPlaceId}};
            }

            let items = this.findDataInStore(params).data;

            if (items.length == 0) return [];

            items = this.populateAppointments(items);
            return this.sortByColor(items);
        },

        fetchAppointments(from, params) {
            return this.find(params);
        },

        dateTime(date, time) {
            time = this.$moment(time);

            return this.$moment(date).set({
                hour: time.hour(),
                minute: time.minute(),
                seconds: 0,
            });
        },
        thisWeek() {
            if (this.view.value === 'month') {
                this.selectDate(this.$moment());
            } else {
                let start = this.$moment();
                let scheduleDay = this.isScheduleDay(start);
                while (!scheduleDay) {
                    start.add(1, 'day');
                    scheduleDay = this.isScheduleDay(start)
                }
                this.start = start.format()
            }
        },
        nextWeek() {
            if (this.view.value === 'month') {
                this.selectDate(this.$moment(this.monthDate).add(1, 'month'));
            } else {
                let view = null;
                if (this.view.value === 'staff')
                    view = this.staffView;
                else if (this.view.value === 'workplace')
                    view = this.workplaceView;
                else
                    view = this.view;

                let start = this.$moment(this.start).add(view.option.value, view.option.type);
                let scheduleDay = this.isScheduleDay(start);
                while (!scheduleDay) {
                    start.add(1, 'day');
                    scheduleDay = this.isScheduleDay(start)
                }
                this.start = start.format()
            }
        },
        prevWeek() {
            if (this.view.value === 'month') {
                this.selectDate(this.$moment(this.monthDate).subtract(1, 'month'));
            } else {
                let view = null;
                if (this.view.value === 'staff')
                    view = this.staffView;
                else if (this.view.value === 'workplace')
                    view = this.workplaceView;
                else
                    view = this.view;

                let start = this.$moment(this.start).subtract(view.option.value, view.option.type);
                let scheduleDay = this.isScheduleDay(start);
                while (!scheduleDay) {
                    start.subtract(1, 'day');
                    scheduleDay = this.isScheduleDay(start)
                }
                this.start = start.format()
            }
        },
        setStep() {
            this.stepRange = this.defaultSteps.findIndex(step => step === this.step);
        },

        async setStepGlobal(step) {
            if (!step)
                return;
            this.stepRange = this.defaultSteps.findIndex(el => el === step);
            this.settings.calendarStep = step;
            this.saveUserSettings();
        },

        stepHandler(event) {
            if (!event.ctrlKey || !this.calenderHover)
                return;

            const index = this.defaultSteps.findIndex(step => step === this.step);

            if (index === -1)
                return;
            let step = 0,
                wheel = event.deltaY;
            switch (true) {
                case wheel < 0:
                    step = this.defaultSteps[Math.min(index + 1, this.defaultSteps.length - 1)];
                    break;
                case wheel > 0:
                    step = this.defaultSteps[Math.max(index - 1, 0)];
                    break
            }

            this.setStepGlobal(step)
        },
        selectDate(newSelectedDate) {
            this.monthDate = newSelectedDate;
        },
        goToCalendarType(date) {
            this.view = {value: 'day', label: 'Day', option: {value: 1, type: 'day'}};
            this.start = date.format();
        },
        formatDate(date) {
            if (this.view.option.value === 1) {
                return this.$moment(date).format('D MMMM, dddd');
            } else if ([3, 7].includes(this.view.option.value)) {
                const weekStartDay = this.$moment(this.heading[0]).format('D');
                const weekEndDay = this.$moment(this.heading[this.heading.length - 1]).format('D');
                const monthNameCurrent = this.$moment(date).format('MMMM')
                const monthNameNext = this.$moment(this.heading[this.heading.length - 1]).format('MMMM')
                let result
                if (monthNameCurrent === monthNameNext) {
                    result = weekStartDay + ' - ' + weekEndDay + ' ' + monthNameCurrent
                } else {
                    result = weekStartDay + ' ' + monthNameCurrent + ' - ' + weekEndDay + ' ' + monthNameNext
                }
                return result
            } else if (this.view.value === 'month') {
                return this.$moment(this.monthDate).format('MMMM YYYY');
            } else {
                return this.$moment(date).format('D MMMM');
            }
        }
    },
    directives: {
        wheel: {
            bind(el, binding, vnode) {
                let f = function(evt) {
                    binding.value(evt, el)
                };
                if (binding.modifiers.debounce)
                    f = debounce(f, parseInt(binding.arg) || 200);
                vnode.context.wheelHandler = f;
                window.addEventListener('wheel', f)
            },

            unbind(el, binding, vnode) {
                window.removeEventListener('wheel', vnode.context.wheelHandler);
            }
        }
    },
}
</script>

<style lang="scss" scoped>
.container-grid {
    display: table;
    border-collapse: collapse;
    border-style: hidden!important;
    box-shadow: 0 0 0 1px #e7ecf3;
    border-radius: 0.5rem;
}

.row-grid {
    display: table-row;
}

.col-1 {
    width: auto;
    display: table-cell;
    text-align: center;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
}

.col-grid {
    display: table-cell;
    text-align: center;
    width: auto;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    border: 1px solid #e7ecf3;
    height: 20px !important;
}

.ghost {
    background-color: red !important;
    border: 1px solid red !important;
}

.col-grid:hover {
    background-color: rgba(241, 240, 207, 0.3);
    cursor: pointer;
}

.today {
    background-color: #ddf299 !important;
}

.timerLine {
    background-color: rgb(241, 240, 207) !important;
}

.only-change-cursor,
.only-change-cursor * {
    cursor: n-resize !important;
}

.popover {
    max-width: 200px;
    width: 50%;
}

.workplace-circle {
    margin: 4.5px auto;
    height: 25px;
    width: 25px;
    border-radius: 100%;
}

.waitingListBadge {
    left: 65%;
    transform: translateX(-65%);
    top: 2px;
    font-size: 11px;
}

.calendar-hour-hover {
    vertical-align: top;

    &:hover {
        .calendar-hour {
            opacity: 1;
            visibility: visible;
        }
    }
}

.calendar-hour {
    visibility: hidden;
    opacity: 0;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
}

@media only screen and (max-width: 360px) {
    .mobileNoPadding {
        padding: 0 5px;
    }
}

@media only screen and (max-width: 576px) {
    .dayNameFitColumn {
        position: absolute;
        font-size: 13px;
        left: 50%;
        transform: translateX(-50%);
        bottom: 1px;
    }
    .dayNameFitColumnPadding {
        padding-bottom: 25px;
    }
}

@media only screen and (max-width: 360px) {
    .mobileNoPadding {
        padding: 0;
    }
}

.btn-group, .btn-group-vertical {
    z-index: 100;

}
</style>

<style lang="scss">
.sticky-calendar-header {
    top: 82px;
    z-index: 2;
    width: 100%;
    position: sticky;
    align-items: center;
}
.vue-simple-context-menu {
    color: #12263F;
    background-color: #FFFFFF;
    border: 1px solid rgba(18, 38, 63, 0.1);
    border-radius: 0.375rem;
    li {
        color: #6E84A3;
        &:hover {
            color: #212529;
            background: none;
        }
    }
}
.bg-custom-white {
    background: #fff;
}
</style>
